import {Dropdown } from "react-bootstrap";
import shopLogo from "../assets/shop_logo.svg";
import "../styles/commonStyles.css";
import { useNavigate } from "react-router-dom";

const Header = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/login");
  };
  return (
    <div className="header-container d-flex flex-row justify-content-between align-items-center">
      <img
        src="https://api.wearepunt.com/img/punt.png"
        alt="Punt Logo"
        className="logo"
        onClick={() => navigate("/")}
      />
      {!window?.location?.href?.includes("login") && (
        <Dropdown>
          <Dropdown.Toggle
            className="fanstore-text d-flex align-items-center justify-content-center gap-2 btn btn-secondary dropdown-toggle"
            type="button"
            id="dropdownMenuButton"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <img src={shopLogo} alt="Punt Logo" />
            <span className="fanstore-text"> Fanstore</span>
          </Dropdown.Toggle>
          <Dropdown.Menu >
            <Dropdown.Item onClick={() => handleLogout()}>
              Logout
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      )}
    </div>
  );
};

export default Header;
